import { render, staticRenderFns } from "./ExpensesLanding.vue?vue&type=template&id=3cd5216c&scoped=true&"
import script from "./ExpensesLanding.vue?vue&type=script&lang=js&"
export * from "./ExpensesLanding.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesLanding.vue?vue&type=style&index=0&id=3cd5216c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5216c",
  null
  
)

export default component.exports